import { RegisteredUserInfo, UserAuthToken } from '~/models/AuthToken'
import { BaseRepository } from '../baseRepository'
import { AuthEntityMapper } from './entityMapper'
import { ApiRegisteredUserInfo, ApiUserAuthToken } from './types'
import { removeUndefinedValues } from '~/models/helpers/removeUndefined'

export class AuthRepository extends BaseRepository {
	static resource = 'auth'

	static async login(email?: string, password?: string, token?: string): Promise<UserAuthToken> {
		const formData = {
			email,
			password,
			token,
		}
		const cleanData = removeUndefinedValues(formData)
		const data = await this.post<ApiUserAuthToken>(`${this.resource}/login/`, cleanData)
		return AuthEntityMapper.obtainTokenInfo(data!)
	}

	static async register(
		email: string,
		password: string,
		registerUrl?: string
	): Promise<RegisteredUserInfo> {
		const formData = {
			email,
			password,
			url: registerUrl,
		}
		const cleanData = removeUndefinedValues(formData)
		const data = await this.post<ApiRegisteredUserInfo>(`${this.resource}/register/`, cleanData)
		return data!
	}

	static async logout(): Promise<void> {
		return await this.post(`${this.resource}/logout/`)
	}

	static async requestPasswordlessLogin(email: string, registerUrl?: string): Promise<void> {
		const formData = {
			email,
			url: registerUrl,
		}
		const cleanData = removeUndefinedValues(formData)
		await this.post<ApiUserAuthToken>(`${this.resource}/login/passwordless/`, cleanData)
	}

	static async loginOAuth(
		provider: string,
		token: string,
		registerUrl?: string
	): Promise<UserAuthToken> {
		const formData = {
			provider,
			token,
			url: registerUrl,
		}
		const cleanData = removeUndefinedValues(formData)
		const data = await this.post<ApiUserAuthToken>(`${this.resource}/login/social/`, cleanData)
		return AuthEntityMapper.obtainTokenInfo(data!)
	}

	static async requestPasswordReset(email: string) {
		return await this.post(`${this.resource}/user/reset_password/`, {
			email,
		})
	}

	static async restorePassword(code: string, email: string, password: string): Promise<void> {
		return await this.post(`${this.resource}/user/restore_password/`, { email, password, code })
	}
}
